import { ChangeEvent, useMemo, useState } from 'react';

import { RoleType } from '../../apollo/__generated__/graphql';
import { useRemoveRoleMutation } from '../../user/hooks/useRemoveRoleMutation';
import { useUsersQuery } from '../../user/hooks/useUsersQuery';

export interface DialogType {
  title: string;
  description: string;
  onSubmit: () => void;
}

export const useAdminUsers = () => {
  const [search, setSearch] = useState<string>('');

  const [addRoleUserId, setAddRoleUserId] = useState<string | null>(null);
  const [dialog, setDialog] = useState<DialogType | null>(null);

  const { data: usersData, loading } = useUsersQuery();
  const { removeRole } = useRemoveRoleMutation();
  const users = useMemo(() => {
    return (usersData?.users ?? []).filter((user) =>
      `${user.firstname} ${user.lastname}. ${user.nickname} ${user.email}`
        .toLowerCase()
        .includes(search.toLowerCase()),
    );
  }, [usersData, search]);

  const onCloseDialog = () => {
    setDialog(null);
  };

  const onRemoveRole = (userId: string, role: RoleType) => {
    setDialog({
      title: 'Suppression du rôle',
      description: `Voulez-vous vraiment supprimer le rôle ${role} ?`,
      onSubmit: () => {
        removeRole({
          role,
          userId,
        });
        onCloseDialog();
      },
    });
  };

  const onAddRole = (userId: string) => {
    setAddRoleUserId(userId);
  };

  const onCloseAddRoleDialog = () => {
    setAddRoleUserId(null);
  };

  const clearSearch = () => {
    setSearch('');
  };

  const onSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  return {
    users,
    loading,
    dialog,
    onCloseDialog,
    onRemoveRole,
    onAddRole,
    onCloseAddRoleDialog,
    addRoleUserId,
    search,
    onSearchChange,
    clearSearch,
  };
};
